@use "../../../../globals/settings";
@use "../../../../globals/bcp";
@use "../../../../globals/bcp-2022/objects/flyouts";

:host {
  @include flyouts.footer();
  display: block;
}

.flyout-footer__content {
  padding: var(--footer-content-padding-top, #{flyouts.$padding-base})
    var(--footer-content-padding-right, #{flyouts.$padding-base})
    var(--footer-content-padding-bottom, #{flyouts.$padding-base})
    var(--footer-content-padding-left, #{flyouts.$padding-base});
}

::slotted([slot="secondary-buttons"]),
[slot="secondary-buttons"] {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: flyouts.$padding-base * -1;

  @include bcp.set-css-var(button-integrated, color, bcp.colorVar("link-text"));
  @include bcp.set-css-var(
    button-integrated-hover,
    color,
    bcp.colorVar("link-hover")
  );
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
